import { format as Se, assign as re, join as ie, isString as z } from "../../../../../@intlify_shared@11.1.12/node_modules/@intlify/shared/dist/shared.js";
/*!
  * message-compiler v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function ke(r, n, c) {
  return { line: r, column: n, offset: c };
}
function q(r, n, c) {
  const a = { start: r, end: n };
  return c != null && (a.source = c), a;
}
const d = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Je = 17, De = {
  // tokenizer error messages
  [d.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [d.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [d.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [d.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [d.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [d.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [d.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [d.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [d.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [d.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [d.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [d.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [d.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [d.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [d.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [d.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function G(r, n, c = {}) {
  const { domain: a, messages: _, args: u } = c, k = process.env.NODE_ENV !== "production" ? Se((_ || De)[r] || "", ...u || []) : r, C = new SyntaxError(String(k));
  return C.code = r, n && (C.location = n), C.domain = a, C;
}
function je(r) {
  throw r;
}
const Oe = /<\/?[\w\s="/.':;#-\/]+>/, Ze = (r) => Oe.test(r), M = " ", Pe = "\r", O = `
`, me = String.fromCharCode(8232), ye = String.fromCharCode(8233);
function be(r) {
  const n = r;
  let c = 0, a = 1, _ = 1, u = 0;
  const k = (p) => n[p] === Pe && n[p + 1] === O, C = (p) => n[p] === O, h = (p) => n[p] === ye, y = (p) => n[p] === me, b = (p) => k(p) || C(p) || h(p) || y(p), T = () => c, A = () => a, R = () => _, v = () => u, P = (p) => k(p) || h(p) || y(p) ? O : n[p], I = () => P(c), i = () => P(c + u);
  function o() {
    return u = 0, b(c) && (a++, _ = 0), k(c) && c++, c++, _++, n[c];
  }
  function E() {
    return k(c + u) && u++, u++, n[c + u];
  }
  function l() {
    c = 0, a = 1, _ = 1, u = 0;
  }
  function L(p = 0) {
    u = p;
  }
  function N() {
    const p = c + u;
    for (; p !== c; )
      o();
    u = 0;
  }
  return {
    index: T,
    line: A,
    column: R,
    peekOffset: v,
    charAt: P,
    currentChar: I,
    currentPeek: i,
    next: o,
    peek: E,
    reset: l,
    resetPeek: L,
    skipToPeek: N
  };
}
const w = void 0, Re = ".", ee = "'", Ue = "tokenizer";
function ve(r, n = {}) {
  const c = n.location !== !1, a = be(r), _ = () => a.index(), u = () => ke(a.line(), a.column(), a.index()), k = u(), C = _(), h = {
    currentType: 13,
    offset: C,
    startLoc: k,
    endLoc: k,
    lastType: 13,
    lastOffset: C,
    lastStartLoc: k,
    lastEndLoc: k,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, y = () => h, { onError: b } = n;
  function T(e, t, s, ...f) {
    const S = y();
    if (t.column += s, t.offset += s, b) {
      const D = c ? q(S.startLoc, t) : null, U = G(e, D, {
        domain: Ue,
        args: f
      });
      b(U);
    }
  }
  function A(e, t, s) {
    e.endLoc = u(), e.currentType = t;
    const f = { type: t };
    return c && (f.loc = q(e.startLoc, e.endLoc)), s != null && (f.value = s), f;
  }
  const R = (e) => A(
    e,
    13
    /* TokenTypes.EOF */
  );
  function v(e, t) {
    return e.currentChar() === t ? (e.next(), t) : (T(d.EXPECTED_TOKEN, u(), 0, t), "");
  }
  function P(e) {
    let t = "";
    for (; e.currentPeek() === M || e.currentPeek() === O; )
      t += e.currentPeek(), e.peek();
    return t;
  }
  function I(e) {
    const t = P(e);
    return e.skipToPeek(), t;
  }
  function i(e) {
    if (e === w)
      return !1;
    const t = e.charCodeAt(0);
    return t >= 97 && t <= 122 || // a-z
    t >= 65 && t <= 90 || // A-Z
    t === 95;
  }
  function o(e) {
    if (e === w)
      return !1;
    const t = e.charCodeAt(0);
    return t >= 48 && t <= 57;
  }
  function E(e, t) {
    const { currentType: s } = t;
    if (s !== 2)
      return !1;
    P(e);
    const f = i(e.currentPeek());
    return e.resetPeek(), f;
  }
  function l(e, t) {
    const { currentType: s } = t;
    if (s !== 2)
      return !1;
    P(e);
    const f = e.currentPeek() === "-" ? e.peek() : e.currentPeek(), S = o(f);
    return e.resetPeek(), S;
  }
  function L(e, t) {
    const { currentType: s } = t;
    if (s !== 2)
      return !1;
    P(e);
    const f = e.currentPeek() === ee;
    return e.resetPeek(), f;
  }
  function N(e, t) {
    const { currentType: s } = t;
    if (s !== 7)
      return !1;
    P(e);
    const f = e.currentPeek() === ".";
    return e.resetPeek(), f;
  }
  function p(e, t) {
    const { currentType: s } = t;
    if (s !== 8)
      return !1;
    P(e);
    const f = i(e.currentPeek());
    return e.resetPeek(), f;
  }
  function H(e, t) {
    const { currentType: s } = t;
    if (!(s === 7 || s === 11))
      return !1;
    P(e);
    const f = e.currentPeek() === ":";
    return e.resetPeek(), f;
  }
  function m(e, t) {
    const { currentType: s } = t;
    if (s !== 9)
      return !1;
    const f = () => {
      const D = e.currentPeek();
      return D === "{" ? i(e.peek()) : D === "@" || D === "|" || D === ":" || D === "." || D === M || !D ? !1 : D === O ? (e.peek(), f()) : F(e, !1);
    }, S = f();
    return e.resetPeek(), S;
  }
  function Y(e) {
    P(e);
    const t = e.currentPeek() === "|";
    return e.resetPeek(), t;
  }
  function F(e, t = !0) {
    const s = (S = !1, D = "") => {
      const U = e.currentPeek();
      return U === "{" || U === "@" || !U ? S : U === "|" ? !(D === M || D === O) : U === M ? (e.peek(), s(!0, M)) : U === O ? (e.peek(), s(!0, O)) : !0;
    }, f = s();
    return t && e.resetPeek(), f;
  }
  function g(e, t) {
    const s = e.currentChar();
    return s === w ? w : t(s) ? (e.next(), s) : null;
  }
  function se(e) {
    const t = e.charCodeAt(0);
    return t >= 97 && t <= 122 || // a-z
    t >= 65 && t <= 90 || // A-Z
    t >= 48 && t <= 57 || // 0-9
    t === 95 || // _
    t === 36;
  }
  function ce(e) {
    return g(e, se);
  }
  function ue(e) {
    const t = e.charCodeAt(0);
    return t >= 97 && t <= 122 || // a-z
    t >= 65 && t <= 90 || // A-Z
    t >= 48 && t <= 57 || // 0-9
    t === 95 || // _
    t === 36 || // $
    t === 45;
  }
  function ae(e) {
    return g(e, ue);
  }
  function oe(e) {
    const t = e.charCodeAt(0);
    return t >= 48 && t <= 57;
  }
  function le(e) {
    return g(e, oe);
  }
  function fe(e) {
    const t = e.charCodeAt(0);
    return t >= 48 && t <= 57 || // 0-9
    t >= 65 && t <= 70 || // A-F
    t >= 97 && t <= 102;
  }
  function Ee(e) {
    return g(e, fe);
  }
  function J(e) {
    let t = "", s = "";
    for (; t = le(e); )
      s += t;
    return s;
  }
  function de(e) {
    let t = "";
    for (; ; ) {
      const s = e.currentChar();
      if (s === "{" || s === "}" || s === "@" || s === "|" || !s)
        break;
      if (s === M || s === O)
        if (F(e))
          t += s, e.next();
        else {
          if (Y(e))
            break;
          t += s, e.next();
        }
      else
        t += s, e.next();
    }
    return t;
  }
  function Le(e) {
    I(e);
    let t = "", s = "";
    for (; t = ae(e); )
      s += t;
    const f = e.currentChar();
    if (f && f !== "}" && f !== w && f !== M && f !== O && f !== "　") {
      const S = Z(e);
      return T(d.INVALID_TOKEN_IN_PLACEHOLDER, u(), 0, s + S), s + S;
    }
    return e.currentChar() === w && T(d.UNTERMINATED_CLOSING_BRACE, u(), 0), s;
  }
  function Ne(e) {
    I(e);
    let t = "";
    return e.currentChar() === "-" ? (e.next(), t += `-${J(e)}`) : t += J(e), e.currentChar() === w && T(d.UNTERMINATED_CLOSING_BRACE, u(), 0), t;
  }
  function _e(e) {
    return e !== ee && e !== O;
  }
  function pe(e) {
    I(e), v(e, "'");
    let t = "", s = "";
    for (; t = g(e, _e); )
      t === "\\" ? s += Ie(e) : s += t;
    const f = e.currentChar();
    return f === O || f === w ? (T(d.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, u(), 0), f === O && (e.next(), v(e, "'")), s) : (v(e, "'"), s);
  }
  function Ie(e) {
    const t = e.currentChar();
    switch (t) {
      case "\\":
      case "'":
        return e.next(), `\\${t}`;
      case "u":
        return j(e, t, 4);
      case "U":
        return j(e, t, 6);
      default:
        return T(d.UNKNOWN_ESCAPE_SEQUENCE, u(), 0, t), "";
    }
  }
  function j(e, t, s) {
    v(e, t);
    let f = "";
    for (let S = 0; S < s; S++) {
      const D = Ee(e);
      if (!D) {
        T(d.INVALID_UNICODE_ESCAPE_SEQUENCE, u(), 0, `\\${t}${f}${e.currentChar()}`);
        break;
      }
      f += D;
    }
    return `\\${t}${f}`;
  }
  function Ce(e) {
    return e !== "{" && e !== "}" && e !== M && e !== O;
  }
  function Z(e) {
    I(e);
    let t = "", s = "";
    for (; t = g(e, Ce); )
      s += t;
    return s;
  }
  function he(e) {
    let t = "", s = "";
    for (; t = ce(e); )
      s += t;
    return s;
  }
  function Te(e) {
    const t = (s) => {
      const f = e.currentChar();
      return f === "{" || f === "@" || f === "|" || f === "(" || f === ")" || !f || f === M ? s : (s += f, e.next(), t(s));
    };
    return t("");
  }
  function V(e) {
    I(e);
    const t = v(
      e,
      "|"
      /* TokenChars.Pipe */
    );
    return I(e), t;
  }
  function B(e, t) {
    let s = null;
    switch (e.currentChar()) {
      case "{":
        return t.braceNest >= 1 && T(d.NOT_ALLOW_NEST_PLACEHOLDER, u(), 0), e.next(), s = A(
          t,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), I(e), t.braceNest++, s;
      case "}":
        return t.braceNest > 0 && t.currentType === 2 && T(d.EMPTY_PLACEHOLDER, u(), 0), e.next(), s = A(
          t,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), t.braceNest--, t.braceNest > 0 && I(e), t.inLinked && t.braceNest === 0 && (t.inLinked = !1), s;
      case "@":
        return t.braceNest > 0 && T(d.UNTERMINATED_CLOSING_BRACE, u(), 0), s = $(e, t) || R(t), t.braceNest = 0, s;
      default: {
        let S = !0, D = !0, U = !0;
        if (Y(e))
          return t.braceNest > 0 && T(d.UNTERMINATED_CLOSING_BRACE, u(), 0), s = A(t, 1, V(e)), t.braceNest = 0, t.inLinked = !1, s;
        if (t.braceNest > 0 && (t.currentType === 4 || t.currentType === 5 || t.currentType === 6))
          return T(d.UNTERMINATED_CLOSING_BRACE, u(), 0), t.braceNest = 0, Q(e, t);
        if (S = E(e, t))
          return s = A(t, 4, Le(e)), I(e), s;
        if (D = l(e, t))
          return s = A(t, 5, Ne(e)), I(e), s;
        if (U = L(e, t))
          return s = A(t, 6, pe(e)), I(e), s;
        if (!S && !D && !U)
          return s = A(t, 12, Z(e)), T(d.INVALID_TOKEN_IN_PLACEHOLDER, u(), 0, s.value), I(e), s;
        break;
      }
    }
    return s;
  }
  function $(e, t) {
    const { currentType: s } = t;
    let f = null;
    const S = e.currentChar();
    switch ((s === 7 || s === 8 || s === 11 || s === 9) && (S === O || S === M) && T(d.INVALID_LINKED_FORMAT, u(), 0), S) {
      case "@":
        return e.next(), f = A(
          t,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), t.inLinked = !0, f;
      case ".":
        return I(e), e.next(), A(
          t,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return I(e), e.next(), A(
          t,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return Y(e) ? (f = A(t, 1, V(e)), t.braceNest = 0, t.inLinked = !1, f) : N(e, t) || H(e, t) ? (I(e), $(e, t)) : p(e, t) ? (I(e), A(t, 11, he(e))) : m(e, t) ? (I(e), S === "{" ? B(e, t) || f : A(t, 10, Te(e))) : (s === 7 && T(d.INVALID_LINKED_FORMAT, u(), 0), t.braceNest = 0, t.inLinked = !1, Q(e, t));
    }
  }
  function Q(e, t) {
    let s = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (t.braceNest > 0)
      return B(e, t) || R(t);
    if (t.inLinked)
      return $(e, t) || R(t);
    switch (e.currentChar()) {
      case "{":
        return B(e, t) || R(t);
      case "}":
        return T(d.UNBALANCED_CLOSING_BRACE, u(), 0), e.next(), A(
          t,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return $(e, t) || R(t);
      default: {
        if (Y(e))
          return s = A(t, 1, V(e)), t.braceNest = 0, t.inLinked = !1, s;
        if (F(e))
          return A(t, 0, de(e));
        break;
      }
    }
    return s;
  }
  function Ae() {
    const { currentType: e, offset: t, startLoc: s, endLoc: f } = h;
    return h.lastType = e, h.lastOffset = t, h.lastStartLoc = s, h.lastEndLoc = f, h.offset = _(), h.startLoc = u(), a.currentChar() === w ? A(
      h,
      13
      /* TokenTypes.EOF */
    ) : Q(a, h);
  }
  return {
    nextToken: Ae,
    currentOffset: _,
    currentPosition: u,
    context: y
  };
}
const Me = "parser", Xe = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function we(r, n, c) {
  switch (r) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const a = parseInt(n || c, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function He(r = {}) {
  const n = r.location !== !1, { onError: c } = r;
  function a(i, o, E, l, ...L) {
    const N = i.currentPosition();
    if (N.offset += l, N.column += l, c) {
      const p = n ? q(E, N) : null, H = G(o, p, {
        domain: Me,
        args: L
      });
      c(H);
    }
  }
  function _(i, o, E) {
    const l = { type: i };
    return n && (l.start = o, l.end = o, l.loc = { start: E, end: E }), l;
  }
  function u(i, o, E, l) {
    n && (i.end = o, i.loc && (i.loc.end = E));
  }
  function k(i, o) {
    const E = i.context(), l = _(3, E.offset, E.startLoc);
    return l.value = o, u(l, i.currentOffset(), i.currentPosition()), l;
  }
  function C(i, o) {
    const E = i.context(), { lastOffset: l, lastStartLoc: L } = E, N = _(5, l, L);
    return N.index = parseInt(o, 10), i.nextToken(), u(N, i.currentOffset(), i.currentPosition()), N;
  }
  function h(i, o) {
    const E = i.context(), { lastOffset: l, lastStartLoc: L } = E, N = _(4, l, L);
    return N.key = o, i.nextToken(), u(N, i.currentOffset(), i.currentPosition()), N;
  }
  function y(i, o) {
    const E = i.context(), { lastOffset: l, lastStartLoc: L } = E, N = _(9, l, L);
    return N.value = o.replace(Xe, we), i.nextToken(), u(N, i.currentOffset(), i.currentPosition()), N;
  }
  function b(i) {
    const o = i.nextToken(), E = i.context(), { lastOffset: l, lastStartLoc: L } = E, N = _(8, l, L);
    return o.type !== 11 ? (a(i, d.UNEXPECTED_EMPTY_LINKED_MODIFIER, E.lastStartLoc, 0), N.value = "", u(N, l, L), {
      nextConsumeToken: o,
      node: N
    }) : (o.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, X(o)), N.value = o.value || "", u(N, i.currentOffset(), i.currentPosition()), {
      node: N
    });
  }
  function T(i, o) {
    const E = i.context(), l = _(7, E.offset, E.startLoc);
    return l.value = o, u(l, i.currentOffset(), i.currentPosition()), l;
  }
  function A(i) {
    const o = i.context(), E = _(6, o.offset, o.startLoc);
    let l = i.nextToken();
    if (l.type === 8) {
      const L = b(i);
      E.modifier = L.node, l = L.nextConsumeToken || i.nextToken();
    }
    switch (l.type !== 9 && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(l)), l = i.nextToken(), l.type === 2 && (l = i.nextToken()), l.type) {
      case 10:
        l.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(l)), E.key = T(i, l.value || "");
        break;
      case 4:
        l.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(l)), E.key = h(i, l.value || "");
        break;
      case 5:
        l.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(l)), E.key = C(i, l.value || "");
        break;
      case 6:
        l.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(l)), E.key = y(i, l.value || "");
        break;
      default: {
        a(i, d.UNEXPECTED_EMPTY_LINKED_KEY, o.lastStartLoc, 0);
        const L = i.context(), N = _(7, L.offset, L.startLoc);
        return N.value = "", u(N, L.offset, L.startLoc), E.key = N, u(E, L.offset, L.startLoc), {
          nextConsumeToken: l,
          node: E
        };
      }
    }
    return u(E, i.currentOffset(), i.currentPosition()), {
      node: E
    };
  }
  function R(i) {
    const o = i.context(), E = o.currentType === 1 ? i.currentOffset() : o.offset, l = o.currentType === 1 ? o.endLoc : o.startLoc, L = _(2, E, l);
    L.items = [];
    let N = null;
    do {
      const m = N || i.nextToken();
      switch (N = null, m.type) {
        case 0:
          m.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(m)), L.items.push(k(i, m.value || ""));
          break;
        case 5:
          m.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(m)), L.items.push(C(i, m.value || ""));
          break;
        case 4:
          m.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(m)), L.items.push(h(i, m.value || ""));
          break;
        case 6:
          m.value == null && a(i, d.UNEXPECTED_LEXICAL_ANALYSIS, o.lastStartLoc, 0, X(m)), L.items.push(y(i, m.value || ""));
          break;
        case 7: {
          const Y = A(i);
          L.items.push(Y.node), N = Y.nextConsumeToken || null;
          break;
        }
      }
    } while (o.currentType !== 13 && o.currentType !== 1);
    const p = o.currentType === 1 ? o.lastOffset : i.currentOffset(), H = o.currentType === 1 ? o.lastEndLoc : i.currentPosition();
    return u(L, p, H), L;
  }
  function v(i, o, E, l) {
    const L = i.context();
    let N = l.items.length === 0;
    const p = _(1, o, E);
    p.cases = [], p.cases.push(l);
    do {
      const H = R(i);
      N || (N = H.items.length === 0), p.cases.push(H);
    } while (L.currentType !== 13);
    return N && a(i, d.MUST_HAVE_MESSAGES_IN_PLURAL, E, 0), u(p, i.currentOffset(), i.currentPosition()), p;
  }
  function P(i) {
    const o = i.context(), { offset: E, startLoc: l } = o, L = R(i);
    return o.currentType === 13 ? L : v(i, E, l, L);
  }
  function I(i) {
    const o = ve(i, re({}, r)), E = o.context(), l = _(0, E.offset, E.startLoc);
    return n && l.loc && (l.loc.source = i), l.body = P(o), r.onCacheKey && (l.cacheKey = r.onCacheKey(i)), E.currentType !== 13 && a(o, d.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, i[E.offset] || ""), u(l, o.currentOffset(), o.currentPosition()), l;
  }
  return { parse: I };
}
function X(r) {
  if (r.type === 13)
    return "EOF";
  const n = (r.value || "").replace(/\r?\n/gu, "\\n");
  return n.length > 10 ? n.slice(0, 9) + "…" : n;
}
function Ye(r, n = {}) {
  const c = {
    ast: r,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => c, helper: (u) => (c.helpers.add(u), u) };
}
function te(r, n) {
  for (let c = 0; c < r.length; c++)
    W(r[c], n);
}
function W(r, n) {
  switch (r.type) {
    case 1:
      te(r.cases, n), n.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      te(r.items, n);
      break;
    case 6: {
      W(r.key, n), n.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), n.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      n.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), n.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      n.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), n.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function ge(r, n = {}) {
  const c = Ye(r);
  c.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), r.body && W(r.body, c);
  const a = c.context();
  r.helpers = Array.from(a.helpers);
}
function Ke(r) {
  const n = r.body;
  return n.type === 2 ? ne(n) : n.cases.forEach((c) => ne(c)), r;
}
function ne(r) {
  if (r.items.length === 1) {
    const n = r.items[0];
    (n.type === 3 || n.type === 9) && (r.static = n.value, delete n.value);
  } else {
    const n = [];
    for (let c = 0; c < r.items.length; c++) {
      const a = r.items[c];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      n.push(a.value);
    }
    if (n.length === r.items.length) {
      r.static = ie(n);
      for (let c = 0; c < r.items.length; c++) {
        const a = r.items[c];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const xe = "minifier";
function K(r) {
  switch (r.t = r.type, r.type) {
    case 0: {
      const n = r;
      K(n.body), n.b = n.body, delete n.body;
      break;
    }
    case 1: {
      const n = r, c = n.cases;
      for (let a = 0; a < c.length; a++)
        K(c[a]);
      n.c = c, delete n.cases;
      break;
    }
    case 2: {
      const n = r, c = n.items;
      for (let a = 0; a < c.length; a++)
        K(c[a]);
      n.i = c, delete n.items, n.static && (n.s = n.static, delete n.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const n = r;
      n.value && (n.v = n.value, delete n.value);
      break;
    }
    case 6: {
      const n = r;
      K(n.key), n.k = n.key, delete n.key, n.modifier && (K(n.modifier), n.m = n.modifier, delete n.modifier);
      break;
    }
    case 5: {
      const n = r;
      n.i = n.index, delete n.index;
      break;
    }
    case 4: {
      const n = r;
      n.k = n.key, delete n.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw G(d.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: xe,
          args: [r.type]
        });
  }
  delete r.type;
}
const $e = "parser";
function Ge(r, n) {
  const { sourceMap: c, filename: a, breakLineCode: _, needIndent: u } = n, k = n.location !== !1, C = {
    filename: a,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: _,
    needIndent: u,
    indentLevel: 0
  };
  k && r.loc && (C.source = r.loc.source);
  const h = () => C;
  function y(I, i) {
    C.code += I;
  }
  function b(I, i = !0) {
    const o = i ? _ : "";
    y(u ? o + "  ".repeat(I) : o);
  }
  function T(I = !0) {
    const i = ++C.indentLevel;
    I && b(i);
  }
  function A(I = !0) {
    const i = --C.indentLevel;
    I && b(i);
  }
  function R() {
    b(C.indentLevel);
  }
  return {
    context: h,
    push: y,
    indent: T,
    deindent: A,
    newline: R,
    helper: (I) => `_${I}`,
    needIndent: () => C.needIndent
  };
}
function Fe(r, n) {
  const { helper: c } = r;
  r.push(`${c(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), x(r, n.key), n.modifier ? (r.push(", "), x(r, n.modifier), r.push(", _type")) : r.push(", undefined, _type"), r.push(")");
}
function Ve(r, n) {
  const { helper: c, needIndent: a } = r;
  r.push(`${c(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), r.indent(a());
  const _ = n.items.length;
  for (let u = 0; u < _ && (x(r, n.items[u]), u !== _ - 1); u++)
    r.push(", ");
  r.deindent(a()), r.push("])");
}
function Be(r, n) {
  const { helper: c, needIndent: a } = r;
  if (n.cases.length > 1) {
    r.push(`${c(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), r.indent(a());
    const _ = n.cases.length;
    for (let u = 0; u < _ && (x(r, n.cases[u]), u !== _ - 1); u++)
      r.push(", ");
    r.deindent(a()), r.push("])");
  }
}
function Qe(r, n) {
  n.body ? x(r, n.body) : r.push("null");
}
function x(r, n) {
  const { helper: c } = r;
  switch (n.type) {
    case 0:
      Qe(r, n);
      break;
    case 1:
      Be(r, n);
      break;
    case 2:
      Ve(r, n);
      break;
    case 6:
      Fe(r, n);
      break;
    case 8:
      r.push(JSON.stringify(n.value), n);
      break;
    case 7:
      r.push(JSON.stringify(n.value), n);
      break;
    case 5:
      r.push(`${c(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${c(
        "list"
        /* HelperNameMap.LIST */
      )}(${n.index}))`, n);
      break;
    case 4:
      r.push(`${c(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${c(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(n.key)}))`, n);
      break;
    case 9:
      r.push(JSON.stringify(n.value), n);
      break;
    case 3:
      r.push(JSON.stringify(n.value), n);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw G(d.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: $e,
          args: [n.type]
        });
  }
}
const qe = (r, n = {}) => {
  const c = z(n.mode) ? n.mode : "normal", a = z(n.filename) ? n.filename : "message.intl", _ = !!n.sourceMap, u = n.breakLineCode != null ? n.breakLineCode : c === "arrow" ? ";" : `
`, k = n.needIndent ? n.needIndent : c !== "arrow", C = r.helpers || [], h = Ge(r, {
    mode: c,
    filename: a,
    sourceMap: _,
    breakLineCode: u,
    needIndent: k
  });
  h.push(c === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), h.indent(k), C.length > 0 && (h.push(`const { ${ie(C.map((T) => `${T}: _${T}`), ", ")} } = ctx`), h.newline()), h.push("return "), x(h, r), h.deindent(k), h.push("}"), delete r.helpers;
  const { code: y, map: b } = h.context();
  return {
    ast: r,
    code: y,
    map: b ? b.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function ze(r, n = {}) {
  const c = re({}, n), a = !!c.jit, _ = !!c.minify, u = c.optimize == null ? !0 : c.optimize, C = He(c).parse(r);
  return a ? (u && Ke(C), _ && K(C), { ast: C, code: "" }) : (ge(C, c), qe(C, c));
}
export {
  Je as COMPILE_ERROR_CODES_EXTEND_POINT,
  d as CompileErrorCodes,
  Me as ERROR_DOMAIN,
  ze as baseCompile,
  G as createCompileError,
  q as createLocation,
  He as createParser,
  ke as createPosition,
  je as defaultOnError,
  Ze as detectHtmlTag,
  De as errorMessages
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@intlify_message-compiler@11.1.12/~/@intlify/message-compiler/dist/message-compiler.js
// module id = 420
// module chunks = 41